const frTranslation = require('./fr.json')
const frSurveyTranslation = require('./frSurveys.json')

const newTranslation = { ...frSurveyTranslation, ...frTranslation }

export default newTranslation
